import { GlobalFilterDetail } from '@/common/entities/filter/GlobalFilterDetail';
import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';

const aesScRoutes = [
  <Route path="/sc/filter" element={<EntityView detailComponent={GlobalFilterDetail} />} />,
  <Route path="/sc/aes-best-price" element={<EntityView />} />,
];

export default aesScRoutes;
